import moment from 'moment'

export const useLocaleDate = (date: Date) => {
  return moment(date).format('DD-MM-YYYY')
}